import React from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  disabled = false
}) => {
  return (
    <div 
      className={`toggle-switch-container ${disabled ? 'disabled' : ''}`}
      onClick={disabled ? undefined : onChange}
    >
      <span className="toggle-label">{label}</span>
      <div className={`toggle-switch ${checked ? 'checked' : ''}`}>
        <div className="toggle-slider" />
      </div>
    </div>
  );
};

export default ToggleSwitch;

